import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

interface RequestQuery {
    category: string;
    list_no: string;
}

interface RequestBody {
    bl_no: string;
    subject: string;
    contents: string;
    company: string;
    m_email: string;
    mobile: string;
}

export type UpdateRequest = RequestQuery & RequestBody;

export interface UpdateResponse {
    statusCode: number;
    message: string;
    data: {
        list_no: number;
    };
}

export const usePutConsoleBillInquiry = (
    successCallback?: (data: UpdateResponse) => void,
): UseMutationResult<UpdateResponse, Error, UpdateRequest, unknown> => {
    const queryClient = useQueryClient();

    return useMutation<UpdateResponse, Error, UpdateRequest>({
        mutationFn: async (updateData: UpdateRequest) => {
            const url = enum_api_uri.put_console_bill.replace(":category", updateData.category).replace(":list_no", updateData.list_no);

            const response = await axiosInstance.put(url, {
                bl_no: updateData.bl_no,
                subject: updateData.subject,
                contents: updateData.contents,
                company: updateData.company,
                m_email: updateData.m_email,
                mobile: updateData.mobile,
            });
            return response.data.data;
        },
        onSuccess: data => {
            queryClient.invalidateQueries({ queryKey: ["useGetConsoleBillInquiryDetail"] });
            successCallback?.(data);
        },
    });
};
